import { apiRequestWrapper } from '~/helpers/apiRequestWrapper'

export async function sendCompanyEmail(id: number, field: string, note: string) {
  const token = useStrapiToken()

  return apiRequestWrapper(`/issuers/companies/${id}/change-request`, {}, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token.value}`,
    },
    body: {
      field,
      note,
    },
  })
}
